export default __webpack_public_path__ + "static/Economic Model Whitepaper - Vietnam-2173819482c955e3c74b509f7747a117.pdf";